/**
 * Processing fee rate (GST-inclusive) charged to retailers on card payments.
 *
 * Was 0.011. Zeroed for Australia's RBA surcharging ban (F2026L00434 Sch 3,
 * effective 2026-10-01) — the ban tests the payment time, not the order time.
 * retailer-api holds the rate that is actually charged, in
 * models/mysql/order_item.ts → PROCESSING_FEE_RATE. Nothing checks that the two
 * match, and this one must not reach 0 before that one does: this side only
 * controls what the retailer is shown.
 *
 * It lives in its own module (rather than inside utils/ProcessingFee.js) so a
 * test can swap the rate with jest.doMock. Spying on ProcessingFee.getRate()
 * does not work: after Babel transpiles the ES exports, fromAmount/fromOrders
 * call the module-local binding, not the property on the exported object.
 */
export const PROCESSING_FEE_RATE = 0;
